var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBudgetComparison(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F0EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 27.016c0-3.252 3.448-5.345 6.333-3.845l10.543 5.482c.47.244 1.012.308 1.525.18l6.23-1.558a4.333 4.333 0 0 1 3.2.442l13.32 7.61a4.333 4.333 0 0 1 2.183 3.763V53a4.333 4.333 0 0 1-4.334 4.333H23.667a4.333 4.333 0 0 1-4.334-4.334V27.016Z",
    fill: "#A0C9BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m47.228 42.877 14.033 5.262a2.167 2.167 0 0 1 1.406 2.03V53a4.333 4.333 0 0 1-4.334 4.333H23.667A4.333 4.333 0 0 1 19.333 53V40c0-1.513 1.511-2.56 2.928-2.029l12.51 5.652a6.5 6.5 0 0 0 3.86.22l4.739-1.185a6.5 6.5 0 0 1 3.858.22Z",
    fill: "#006C52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetComparison);
export default __webpack_public_path__ + "static/media/budget-comparison.ad97e2e8.svg";
export { ForwardRef as ReactComponent };